import MotivoRechazo from '../../../models/pesado/motivos_rechazo'
import MotivoRechazoCamiones from '../../../models/camiones/motivos_rechazo'

export function requestMotivosRechazo (tipo = 'PESADO') {
  return dispatch => {
    dispatch({ type: 'REQUEST_MOTIVOS_RECHAZO' })
    if (tipo === 'PESADO') {
      return MotivoRechazo.getMotivos()
        .then((motivosRechazo) => dispatch({
          type: 'RECEIVE_MOTIVOS_RECHAZO',
          motivosRechazo
        }))
        .catch(_ => dispatch({
          type: 'RECEIVE_MOTIVOS_RECHAZO',
          motivosRechazo: []
        }))
    } else if (tipo === 'PLAYA') {
      return MotivoRechazoCamiones.getAll()
        .then((motivosRechazo) => dispatch({
          type: 'RECEIVE_MOTIVOS_RECHAZO',
          motivosRechazo
        }, console.log(motivosRechazo)))
        .catch(_ => dispatch({
          type: 'RECEIVE_MOTIVOS_RECHAZO',
          motivosRechazo: []
        }))
    }
  }
}

export function setMotivoRechazo (motivoRechazo) {
  return dispatch => {
    dispatch({
      type: 'SET_MOTIVO_RECHAZO',
      motivoRechazo
    })
  }
}
